import React, { useEffect } from 'react';

export const usePreventUserRemoveModal = (isUserSuspended) => {
  //Detectar cuando el usuario elimina el modal y recargar la app
  useEffect(() => {
    const observerModalUserSuspended = document.getElementById(
      'user-suspended-modal',
    );

    const isModalRemoved = !observerModalUserSuspended && isUserSuspended;

    if (isModalRemoved) window.location.reload();
  });

  //Agregar los estilos desde la referencia
  useEffect(() => {
    const observerModalUserSuspended = document.getElementById(
      'user-suspended-modal',
    );
    if (!observerModalUserSuspended) return;
    observerModalUserSuspended.style.display = 'block';
    observerModalUserSuspended.style.backgroundColor = '#000';
    observerModalUserSuspended.style.height = '100vh';
    observerModalUserSuspended.style.width = '100vw';
    observerModalUserSuspended.style.position = 'fixed';
    observerModalUserSuspended.style.top = '0';
    observerModalUserSuspended.style.bottom = '0';
    observerModalUserSuspended.style.zIndex = '9999';
  });
};
